export default __webpack_public_path__ + "static/media/shoes.962a5f60.png";